<template>
  <div v-if="isIconVisible">
    <a-icon
      :icon="currentIcon"
      :width="width"
      :height="height"
      no-hover
      original
    />
  </div>
</template>

<script>
import AIcon, { ICON } from 'shared/AIcon'
import { SHOW_ONE_SIGNAL_ICON_BUS_NAME } from 'enums/oneSignal'
import { propValidator, PROP_TYPES } from '@/utils/validators'
import { removeNode } from '@/plugins/helper'

export default {
  name: 'AOneSignalIcon',
  components: { AIcon },
  props: {
    width: propValidator([PROP_TYPES.NUMBER]),
    height: propValidator([PROP_TYPES.NUMBER])
  },
  data() {
    return {
      currentIcon: ICON.MEGAPHONE_INACTIVE,
      isIconVisible: false
    }
  },
  methods: {
    showOneSignalIcon(isSubscribed) {
      this.currentIcon = isSubscribed
        ? ICON.MEGAPHONE_INACTIVE
        : ICON.MEGAPHONE_ACTIVE

      this.isIconVisible = true
    },
    syncOneSignalIconVisibility() {
      if (typeof window === 'undefined' || !window.OneSignal) return

      window.OneSignal.push(async () => {
        try {
          const isSubscribed = await window.OneSignal.getSubscription()
          this.showOneSignalIcon(isSubscribed)
        } catch (_) {
          // Fail silently — icon visibility is non-critical
        }
      })
    },
    garbageCollectIcon() {
      const parent = this.$el.parentElement

      if (!parent) return

      const elementToRemove = this.$helper.getElByDataRef(
        this.$attrs['data-ref'],
        parent
      )

      if (!elementToRemove) return

      removeNode(elementToRemove)
    }
  },
  mounted() {
    this.$bus.$on(SHOW_ONE_SIGNAL_ICON_BUS_NAME, this.showOneSignalIcon)
    this.syncOneSignalIconVisibility()
  },
  beforeDestroy() {
    this.$bus.$off(SHOW_ONE_SIGNAL_ICON_BUS_NAME, this.showOneSignalIcon)
    this.garbageCollectIcon()
  }
}
</script>
